<template>
	<card class="card-default mt-4">
		<card-header class="d-flex">
			<strong>{{ campaign.name }}</strong> <span class="id align-self-center">id:({{ campaign.id }})</span>
			<div class="ml-auto">
                <button class="btn btn-default btn-sm btn-icon ml-1" title="Duplicate"
					@click="replicate(campaign.id)">
                    <i class="fa fa-fw fa-copy"></i>
                </button>

                <button class="btn btn-default btn-sm btn-icon ml-1" title="Delete"
                    @click="remove">
                    <i class="fa fa-fw fa-trash"></i>
                </button>

				<a class="btn btn-default btn-sm btn-icon ml-1" title="Edit" :href="editUrl">
                    <i class="fa fa-fw fa-pencil-alt"></i>
                </a>
			</div>
		</card-header>

		<card-body class="pt-0">
			 <div class="form-row">
				<div class="col-md-3">
                    <img class="mw-100 mb-2 rounded" :src="image_url" />
                    <button class="btn btn-default btn-block" @click="openSmsPreview(campaign)">
                        Preview SMS
                        <i class="fas fa-comment-alt ml-2"></i>
                    </button>
                    <button class="btn btn-default btn-block" @click="openEmailPreview(campaign)">
                        Preview Email
                        <i class="fas fa-envelope ml-2"></i>
                    </button>
                </div>

				<!--<div class="col-md-9">-->
					<!--<campaign-metrics :data="metrics_campaign" :expanded.sync="expand"/>-->
				<!--</div>-->

			</div>

			<transition name="fade">
				<div class="form-row mt-3" ref="details" v-if="expand">
					<div class="col-md-3">
						<div class="panel">
							<div class="panel-header">Locations</div>
							<div class="panel-body p-0" style="max-height: 200px; overflow-y: auto;">
								<ul class="list-group list-group-flush">
									<li class="list-group-item"
                                        v-for="location of campaign.locations"
                                        :key="location.id">
                                        <i class="fa fa-map-marker-alt mr-2"></i>
                                        {{ location.name }}
                                    </li>
								</ul>
							</div>
						</div>
					</div>
					<div class="col-md-9">
						<div class="form-row mb-3">
							<div class="col">
								<div class="panel">
									<div class="panel-header">Response Metrics</div>
									<div class="panel-body">
										<sites-metrics :show-bars="true" :data="campaign.metrics_site"/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</transition>
		</card-body>
	</card>
</template>

<script>
export default {
    props: ['campaign'],

    data() {
        return {
            expand: false,
            options: {
                type: 'warning',
                title: 'Make a copy?',
                text: 'You wanna make a copy of this campaign?',
                confirmButtonText: 'Make a copy',
                closeOnConfirm: true
            },
            metrics_campaign: {
                contacts_sent: 0,
                click_through_rate: {
                    value:0,
                    percent:0
                }
            },
        }
    },

    computed: {
        image_url() {
            return this.campaign.image_url || '/img/image.jpg';
        },

        editUrl() {
            return this.$laroute.route('campaigns.workflow.edit', {workflow: this.campaign.id});
        },
    },

    mounted() {
        this.setMetrics(this.campaign);

        $(this.$refs.details).hide();
    },

    methods: {
        remove() {
            this.$confirm().then(() => {
                const url = this.$laroute.route('api.workflow-campaigns.destroy', { id: this.campaign.id });
                this.$http.delete(url)
                    .then(res => {
                        const message = res.data.message;
                        this.$alert({ message, type: 'success', title: 'Success!' });
                        this.$emit('deleted');
                    })
                    .catch(err => console.log('err from delete', err))
            });
        },

        replicate(id) {
            this.$confirm(this.options).then(() => {
                this.$http.post(this.$laroute.route('api.campaigns.replicate', {campaign: id }))
                    .then(({ data }) => this.$emit('replicated'))
            });
        },

        setMetrics(campaign) {
            this.metrics_campaign.contacts_sent = 11;//campaign.message_users.length ? campaign.message_users.length : 0;
            // this.metrics_campaign.click_through_rate.value = 11;//campaign.message_users.length ? campaign.message_users.length : 0;
            // this.metrics_campaign.click_through_rate.percent = 11;//campaign.message_users.length ? campaign.message_users.length : 0;
        },

        openSmsPreview(campaign) {
            this.$parent.openSmsPreview(campaign);
        },

        openEmailPreview(campaign) {
            this.$parent.openEmailPreview(campaign);
        }
    }
}
</script>

<style scoped>
    .id {
        font-size: 0.8em;
        padding-left: 5px;
        color: #B2B2B2;
    }
</style>
